import { render, staticRenderFns } from "./FamilyMember.vue?vue&type=template&id=3bf7376e&scoped=true&"
import script from "./FamilyMember.vue?vue&type=script&lang=js&"
export * from "./FamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./FamilyMember.vue?vue&type=style&index=0&id=3bf7376e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7376e",
  null
  
)

component.options.__file = "FamilyMember.vue"
export default component.exports